/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Tab_HistoryInputs */

const en_us2_exercise_sheet_tab_history = /** @type {(inputs: Exercise_Sheet_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const pt_br2_exercise_sheet_tab_history = /** @type {(inputs: Exercise_Sheet_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico`)
};

const es_419_exercise_sheet_tab_history = /** @type {(inputs: Exercise_Sheet_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial`)
};

const pt_pt2_exercise_sheet_tab_history = /** @type {(inputs: Exercise_Sheet_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico`)
};

const fr_fr2_exercise_sheet_tab_history = /** @type {(inputs: Exercise_Sheet_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique`)
};

const de_de2_exercise_sheet_tab_history = /** @type {(inputs: Exercise_Sheet_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlauf`)
};

const it_it2_exercise_sheet_tab_history = /** @type {(inputs: Exercise_Sheet_Tab_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storico`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {Exercise_Sheet_Tab_HistoryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_tab_history = /** @type {((inputs?: Exercise_Sheet_Tab_HistoryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Tab_HistoryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_tab_history(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_tab_history(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_tab_history(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_tab_history(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_tab_history(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_tab_history(inputs)
	return en_us2_exercise_sheet_tab_history(inputs)
});
export { exercise_sheet_tab_history as "exercise-sheet.tab_history" }